import { Checkbox } from '@mui/material';
import { CheckCircle, RadioButtonUnchecked } from '@mui/icons-material';
import React from 'react';

interface OnboardingOptionItemProps {
  isSelected: boolean;
  onClick: () => void;
  icon: React.ReactElement;
  label: string;
  readOnly?: boolean;
}

export const OnboardingOptionItem: React.FC<OnboardingOptionItemProps> = ({
  isSelected,
  onClick,
  icon,
  label,
  readOnly = false,
}) => {
  const baseClass = 'onboarding-option';
  const classes = [
    baseClass,
    isSelected && `${baseClass}--selected`,
    readOnly && `${baseClass}--readonly`,
  ].filter(Boolean).join(' ');

  return (
    <div
      className={classes}
      onClick={readOnly ? undefined : onClick}
      role="button"
      tabIndex={readOnly ? -1 : 0}
      onKeyDown={(e) => {
        if (!readOnly && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <span className={`${baseClass}__checkbox`}>
        <Checkbox
          checked={isSelected}
          icon={<RadioButtonUnchecked />}
          checkedIcon={<CheckCircle />}
          sx={{ color: 'primary.main', p: 0, '&.Mui-checked': { color: 'primary.main' } }}
        />
      </span>
      <span className={`${baseClass}__icon`}>{icon}</span>
      <span className={`${baseClass}__label`}>{label}</span>
    </div>
  );
};
